export default __webpack_public_path__ + "static/drmc-37e545bb8ce5d1b5a0d6d3977dd27eea.png";